import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import React, { CSSProperties, useState } from 'react';

type Props = {
  content: React.ReactNode;
  tip: React.ReactNode;
  className?: string;
  style?: CSSProperties;
};
export default ({ content, tip, className, style }: Props) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className={className} style={style}>
      <span
        onClick={() => {
          setVisible(!visible);
        }}>
        {tip} {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
      </span>
      <div>{visible ? content : null}</div>
    </div>
  );
};
